export default __webpack_public_path__ + "static/media/page-1-mb.d2a441f0.png";